(ns dre.widgets.data-sources.views
  (:require
   [dre.components.widget.views :as widget-base] 
   [dre.components.widget.views.common :refer [no-result title-with-filter]]
   [dre.components.widget.views.table-list :refer [table-list]]
   [dre.i18n.views :refer [tr]]
   [dre.widgets.data-sources.events :as-alias events]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn widget-content
  [_ _]
  (fn [data total-count]
    [:<>
     (if (not (seq data))
       [no-result true]
       [table-list "data-source-table" data {:total-count total-count}])]))

(defn view
  [id title]
  (let [state @(rf/subscribe [::events/state])
        data @(rf/subscribe [::events/data])
        total-count @(rf/subscribe [::events/total-count])
        loading? (= :loading (:state state))]
    [widget-base/view id [title-with-filter title id] [widget-content data total-count]
     {:csv-event [::events/export]
      :export-image? false
      :tooltip (r/as-element [:span
                              [tr "The list of data sources below indicates the number of references matching your search string from each source. 
                                   Dr.Evidence removes duplicates from the Results list for some overlapping sources, only showing one instance of the reference. You will see differences between the counts in this widget and the Results list. 
                                   Sources currently de-duped include: PubMed Central, PubMed, and CORD19."]])}
     {:loading? loading?}]))
